import { userResponse } from '../xhr/getUsers';

interface SelectedUser {
  id?: string;
  uuid?: string;
}

export function handleUserSelectionClick(
  user: userResponse,
  selected: SelectedUser[],
  setSelected: (fn: (prev: SelectedUser[]) => SelectedUser[]) => void,
  selectedUserList: userResponse[],
  setSelectedUserList: (fn: (prev: userResponse[]) => userResponse[]) => void,
  setTerm: (term: string) => void,
  setTypeahead: (value: string) => void
): void {
  const userIdStr = user.id != null ? user.id.toString() : '';
  const userUuid = user.uuid ?? '';

  if (!userIdStr) return; 

  const isSelected = selected.some(selectedUser => selectedUser.id === userIdStr);
  const isInList = selectedUserList.some(selectedUser => selectedUser.id === user.id);

  if (isSelected) {
    setSelected(prev => prev.filter(f => f.id !== userIdStr));
  } else {
    setSelected(prev => [...prev, { id: userIdStr, uuid: userUuid }]);
  }

  if (isInList) {
    setSelectedUserList(prev => prev.filter(f => f.id !== user.id));
  } else {
    setSelectedUserList(prev => [...prev, user]);
  }

  setTerm('');
  setTypeahead('');
}
